module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/characters/esmeralda_goober_goofy_smile-ea36a1f2dea26b0654b664d4bb49cb2f.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/characters/esmeralda_goober_goofy_smile.png
// module id = 885
// module chunks = 2